import ApiService from '@/core/services/api.service';

export class ProductStorePricingService {
  static async getStorePrices(productId, params = {}) {
    try {
      const response = await ApiService.get(
        `/v1/product-store-pricing/products/${productId}/stores`,
        {
          params: {
            page: 1,
            limit: 10,
            ...params,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching store prices:', error);
      throw error;
    }
  }

  static async setStorePrice(productId, storeId, data) {
    try {
      const response = await ApiService.put(
        `/v1/product-store-pricing/products/${productId}/stores/${storeId}`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error('Error setting store price:', error);
      throw error;
    }
  }

  static async deleteStorePrice(productId, storeId) {
    try {
      const response = await ApiService.delete(
        `/v1/product-store-pricing/products/${productId}/stores/${storeId}`,
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting store price:', error);
      throw error;
    }
  }

  static async getPriceHistory(productId, params = {}) {
    try {
      const response = await ApiService.get(
        `/v1/product-store-pricing/products/${productId}/history`,
        {
          params: {
            page: 1,
            limit: 10,
            ...params,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching price history:', error);
      throw error;
    }
  }

  static async importPricing(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await ApiService.post(
        '/v1/product-store-pricing/import',
        formData,
      );
      return response.data;
    } catch (error) {
      console.error('Error importing pricing:', error);
      throw error;
    }
  }

  static async downloadTemplate() {
    try {
      const response = await ApiService.get(
        '/v1/product-store-pricing/import/template',
        {
          responseType: 'blob',
        },
      );
      return response;
    } catch (error) {
      console.error('Error downloading template:', error);
      throw error;
    }
  }
}
